import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_th = _resolveComponent("b-th")!
  const _component_b_tr = _resolveComponent("b-tr")!
  const _component_b_thead = _resolveComponent("b-thead")!
  const _component_b_td = _resolveComponent("b-td")!
  const _component_b_tbody = _resolveComponent("b-tbody")!
  const _component_b_table_simple = _resolveComponent("b-table-simple")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Загрузка..."))
      : (_openBlock(), _createBlock(_component_b_table_simple, {
          key: 1,
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_thead, { "head-variant": "light" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_tr, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_th, null, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode("#")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_b_th, null, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode("Учетный месяц")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_b_th, null, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("Учетный год")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_b_th, null, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("Количество дней фактического пребывания")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_b_th, null, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Количество дней планируемого пребывания (только в план табеле)")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_b_th, null, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("Дни отсутствия по уважительной причине")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_b_th, null, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("Дни отсутствия по неуважительной причине")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_b_th, null, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("Дни, в которых более 40 дней БП (без причины)")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_tbody, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childTimesheetInfoResponse, (data, index) => {
                  return (_openBlock(), _createBlock(_component_b_tr, { key: index }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_td, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(index + 1), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_b_td, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.accountingMonth), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_b_td, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.accountingYear), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_b_td, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.factPresenceDays), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_b_td, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.planPresenceDays), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_b_td, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.excusedAbsenceDays), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_b_td, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.unexcusedAbsenceDays), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_b_td, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.absenceRedLine), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}